export default __webpack_public_path__ + "static/media/fastener-placement-square-rounded-bottom.acc22e25.webp";